<template>
  <div class="periods">
    <div class="periods__content">
      <div class="periods__title">{{ title }}</div>
      <div class="periods__list list">
        <component
          :is="getComponentItem(item)"
          v-for="item in items"
          :key="item.id"
          class="list__item"
          :class="getClassListItem(item)"
          v-bind="getPropsItem(item)"
          colorless
          @click="OnClickItem"
        >
          {{ item.title }}
        </component>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BHLink from '~/components/BHLink.vue';
  import { useWindowStore } from '~/store/window';

  interface ISwitchItem {
    id?: string;
    title?: string;
    isActive: boolean;
    link: HTMLAnchorElement;
  }

  export default defineNuxtComponent({
    name: 'ArchiveTopPeriods',

    components: {
      BHLink,
    },

    props: {
      title: {
        type: String as PropType<string>,
        required: true,
      },

      items: {
        type: Array as PropType<Array<ISwitchItem>>,
        required: true,
      },
    },

    emits: ['close'],

    computed: {
      isMobile() {
        return useWindowStore().isMobile;
      },

      currentItem(): ISwitchItem {
        const [activeItem] = this.items.filter((item: ISwitchItem) => item.isActive);

        return activeItem;
      },

      listClass() {
        return {
          'list--mobile': this.isMobile,
        };
      },
    },

    methods: {
      getClassListItem(item: ISwitchItem) {
        return {
          'list__item--current': item.isActive,
        };
      },

      getComponentItem(item: ISwitchItem): string {
        return item.isActive ? 'span' : 'BHLink';
      },

      getPropsItem(item: ISwitchItem) {
        return item.isActive
          ? null
          : {
              href: item.link.href,
            };
      },

      OnClickItem() {
        this.$emit('close');
      },
    },
  });
</script>

<style lang="scss" scoped>
  .periods {
    &__title {
      font-family: $text-font--1;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      padding: 16px;

      @include tablet {
        display: none;
      }
    }
  }

  .list {
    $list: &;

    &__item {
      display: flex;
      justify-content: space-between;
      font-family: $text-font--1;
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      padding: 16px;
      position: relative;

      &--current {
        &:after {
          content: '';
          display: block;
          width: 20px;
          height: 20px;
          @include acceptIcon;
          background-color: $actionUiColor;
        }
      }
    }

    @include tablet {
      display: flex;
      flex-wrap: nowrap;

      &__item {
        display: flex;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: $icon-color--1;
        padding: 12px 16px;
        border: 1px solid transparent;

        &:hover {
          &:not([class$='--current']) {
            color: $mainBlack;
          }
        }

        &--current {
          &:after {
            display: none;
          }

          border-color: $actionUiColor;
          color: $actionUiColor;
          cursor: default;
          border-radius: 50%;
        }
      }
    }
  }
</style>
